import { tcf } from '@m10s/CMP'
import getConfig from 'next/config'
import { gtmOnConsentChange } from './gtmConsent'

const { publicRuntimeConfig } = getConfig()
const isProd = publicRuntimeConfig.BASEURL === 'https://www.blocket.se'

const defaultCookieConsentConfig = {
  baseEndpoint: 'https://cmpv2.blocket.se',
  consentLanguage: 'sv',
  pulseObjectName: 'blocketPulse',
  showInWebview: 'tcf',
  realm: 'schibsted.com',
}

const VendCookieConsentConfig = isProd
  ? {
      ...defaultCookieConsentConfig,
      propertyId: 35387,
      groupPmId: 1156182,
    }
  : {
      ...defaultCookieConsentConfig,
      propertyId: 35962,
      groupPmId: 1162875,
      propertyHref: 'https://www.blocket.dev',
    }

const CATEGORIES = {
  ADVERTISING: 'CMP:advertising',
  ANALYTICS: 'CMP:analytics',
  MARKETING: 'CMP:marketing',
  PERSONALISATION: 'CMP:personalisation',
}

export const setupAndShowCookieConsentModal = (userId) => {
  // The Schibsted account user identifier for the logged in user. Send only if user is logged in.
  if (userId) {
    VendCookieConsentConfig.userId = userId
  }
  tcf(window, document, navigator, VendCookieConsentConfig)
}

export const reopenCookieConsentModal = () => {
  window._tcf_.showPrivacyManager()
}

const consentSettings = {
  advertising: false,
  analytics: false,
  marketing: false,
  personalisation: false,
}

const subscriptionUpdate = (category, value) => {
  // "1" - cookies could be set, "0" - cookies could NOT be set
  consentSettings[category] = value === '1'

  gtmOnConsentChange(consentSettings)
}

export const subscribeCookieConsent = () => {
  window._tcf_.subscribe(CATEGORIES.ADVERTISING, (value) =>
    subscriptionUpdate('advertising', value),
  )
  window._tcf_.subscribe(CATEGORIES.MARKETING, (value) => subscriptionUpdate('marketing', value))
  window._tcf_.subscribe(CATEGORIES.ANALYTICS, (value) => subscriptionUpdate('analytics', value))
  window._tcf_.subscribe(CATEGORIES.PERSONALISATION, (value) =>
    subscriptionUpdate('personalisation', value),
  )
}
